var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "95%",
      "height": "auto",
      "is-loc": "center"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "energy__subtitle"
  }, [_vm._v(" New Round Live! ")]), _c('div', {
    staticClass: "energy__threetitle"
  }, [_vm._v(" Place your bets now—don’t miss out! ")]), _c('div', {
    staticClass: "btn-level",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Join Round ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };